import React from 'react';
import './TrustedSection.css';

const companies = [
  {
    name: 'Google',
    light: 'https://cdn.brandfetch.io/id6O2oGzv-/theme/dark/logo.svg?c=1dxbfHSJFAPEGdCLU4o5B',
    dark: 'https://cdn.brandfetch.io/id6O2oGzv-/theme/dark/logo.svg?c=1dxbfHSJFAPEGdCLU4o5B'
  },
  {
    name: 'Meta',
    light: 'https://cdn.brandfetch.io/idWvz5T3V7/theme/dark/logo.svg?c=1dxbfHSJFAPEGdCLU4o5B',
    dark: 'https://cdn.brandfetch.io/idWvz5T3V7/theme/light/logo.svg?c=1dxbfHSJFAPEGdCLU4o5B'
  },
  {
    name: 'Infosys',
    light: 'https://cdn.brandfetch.io/id2jVuQy_9/theme/dark/logo.svg?c=1dxbfHSJFAPEGdCLU4o5B',
    dark: 'https://cdn.brandfetch.io/id2jVuQy_9/theme/light/logo.svg?c=1dxbfHSJFAPEGdCLU4o5B'
  },
  {
    name: 'IBM',
    light: 'https://upload.wikimedia.org/wikipedia/commons/5/51/IBM_logo.svg',
    dark: 'https://upload.wikimedia.org/wikipedia/commons/5/51/IBM_logo.svg'
  },
  {
    name: 'Capgemini',
    light: 'https://cdn.brandfetch.io/idbJBNV8BD/theme/dark/logo.svg?c=1dxbfHSJFAPEGdCLU4o5B',
    dark: 'https://cdn.brandfetch.io/idbJBNV8BD/theme/dark/logo.svg?c=1dxbfHSJFAPEGdCLU4o5B'
  },
  {
    name: 'Amazon',
    light: 'https://cdn.brandfetch.io/idawOgYOsG/theme/dark/logo.svg?c=1dxbfHSJFAPEGdCLU4o5B',
    dark: 'https://cdn.brandfetch.io/idawOgYOsG/theme/light/logo.svg?c=1dxbfHSJFAPEGdCLU4o5B'
  },
  {
    name: 'Microsoft',
    light: 'https://cdn.brandfetch.io/idchmboHEZ/theme/dark/logo.svg?c=1dxbfHSJFAPEGdCLU4o5B',
    dark: 'https://cdn.brandfetch.io/idchmboHEZ/theme/dark/logo.svg?c=1dxbfHSJFAPEGdCLU4o5B'
  },
  {
    name: 'Wipro',
    light: 'https://cdn.brandfetch.io/id1uICo497/theme/dark/logo.svg?c=1dxbfHSJFAPEGdCLU4o5B',
    dark: 'https://cdn.brandfetch.io/id1uICo497/theme/dark/logo.svg?c=1dxbfHSJFAPEGdCLU4o5B'
  },
  {
    name: 'Deloitte',
    light: 'https://cdn.brandfetch.io/idIu-Ji9Le/theme/dark/logo.svg?c=1dxbfHSJFAPEGdCLU4o5B',
    dark: 'https://cdn.brandfetch.io/idIu-Ji9Le/theme/light/logo.svg?c=1dxbfHSJFAPEGdCLU4o5B'
  },
  {
    name: 'KPMG',
    light: 'https://cdn.brandfetch.io/id-UmnExAG/theme/dark/logo.svg?c=1dxbfHSJFAPEGdCLU4o5B',
    dark: 'https://cdn.brandfetch.io/id-UmnExAG/theme/light/logo.svg?c=1dxbfHSJFAPEGdCLU4o5B'
  }
];

const TrustedSection = ({ theme }) => {
  return (
    <section className={`trusted-section-ats theme-${theme}`}>
      <h2 className="trusted-title-ats">
        <span className="trusted-main-text">
          TRUSTED BY JOB SEEKERS WHO'VE LANDED ROLES AT TOP-TIER COMPANIES.
        </span>
        <br />
        <span className="trusted-sub-text">
          OUR USERS HAVE BEEN HIRED BY LEADING NAMES IN THE INDUSTRY
        </span>
      </h2>
      
      <div className="marquee-wrapper-ats">
        <div className="marquee-ats">
          <div className="marquee-track-ats">
            {/* First set */}
            {companies.map((company, index) => (
              <div className="company-logo-ats" key={`set1-${company.name}-${index}`}>
                <img
                  src={theme === 'dark' ? company.dark : company.light}
                  alt={company.name}
                  title={company.name}
                  loading="lazy"
                />
              </div>
            ))}
            {/* Second set for seamless loop */}
            {companies.map((company, index) => (
              <div className="company-logo-ats" key={`set2-${company.name}-${index}`}>
                <img
                  src={theme === 'dark' ? company.dark : company.light}
                  alt={company.name}
                  title={company.name}
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustedSection;